<template>
	<div class="show-more-accordion">
		<button class="show-more-button"
		        data-show-more-button
		        type="button"
		        @click="toggleBlock()">

			<span class="text" v-text="open ? showLessText : showMoreText"></span>

			<span aria-hidden="true" class="icon">
				<icon-chevron-down v-if="open" :size="12" />
				<icon-chevron-up v-if="!open" :size="12" />
			</span>
		</button>

		<div v-if="open" class="content">
			<slot />
		</div>
	</div>
</template>

<script lang="ts" setup>
import {ref} from 'vue';
import IconChevronUp from '@/components/icons/IconChevronUp.vue';
import IconChevronDown from '@/components/icons/IconChevronDown.vue';

interface Props {
		showMoreText?: string,
		showLessText?: string
	}

	const props = withDefaults(defineProps<Props>(), {
		showMoreText: 'Toon meer',
		showLessText: 'Toon minder'
	});

	const open = ref(false);

	const toggleBlock = () => open.value = !open.value;
</script>

<style lang="scss" scoped>
	button {
		background: none;
		border: none;
		display: block;
		color: var(--color-primary_blue);
		font: inherit;
		cursor: pointer;
	}

	.icon {
		margin-left: 1ex;
	}
</style>
